import { env } from 'config/env';
import { ThemeState } from 'design-system';
import { Stack } from 'expo-router';
import { useUserSession } from 'hooks';
import { useCachedResources } from 'hooks/useCachedResources';
import { AuthApi } from 'integration/AuthApi';
import { UserProvider } from 'providers';

const authClient = AuthApi.getInstance({
  clientId: env.auth0ClientId,
  domain: env.auth0Domain,
});

function RootNavigator() {
  const session = useUserSession();

  const isAuthenticated = Boolean(session.user);

  return (
    <Stack>
      <Stack.Protected guard={isAuthenticated}>
        <Stack.Screen name="(app)" options={{ headerShown: false }} />
      </Stack.Protected>

      <Stack.Protected guard={!isAuthenticated}>
        <Stack.Screen name="login" options={{ headerShown: false }} />
      </Stack.Protected>
    </Stack>
  );
}

export default function Root() {
  const isLoadingComplete = useCachedResources();

  if (!isLoadingComplete) {
    return null;
  }
  // Set up the auth context and render our layout inside of it.
  return (
    <ThemeState>
      <UserProvider authClient={authClient}>
        <RootNavigator />
      </UserProvider>
    </ThemeState>
  );
}
